export default __webpack_public_path__ + "static/media/GFBOT-Horizontal.0e569693.png";